import React from "react";

import Feature from "@/components/_common/Feature";

import "./featured-articles.scss";

export default class FeaturedArticles extends React.Component {
  render() {
    const { items } = this.props;
    const altText = [
      'Discover Guinness Open Gate Brewery on James Street, Dublin. Try our innovate experimental beers while you feast on our delicious menu options.',
      'Discover Guinness Open Gate Brewery on James Street, Dublin. Try our innovate experimental beers while you feast on our delicious menu options.',
      'Welcome to the Open Gate Brewery, the home of innovation for Guinness. Experience the excitement of experimental beers right here at this working brewery'
    ]
    const updatedItems = items.map((item, itemIndex) => {
      const updatedImages = item["IMAGE FILE NAME"].map((image, imageIndex) => ({
        ...image,
        alternateText: altText[itemIndex]
      }));
      return {
        ...item,
        "IMAGE FILE NAME": updatedImages,
      };
    });
    
    return (
      <div className="FeaturedArticles">
        {updatedItems &&
          updatedItems.map((item, index) => (
            <Feature
              className="feature feature--home"
              article={item}
              index={index}
            />
          ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/FeaturedArticles/index.js